




































































































































































































































































































import {
  Component, Prop, Vue, PropSync, Watch,
} from 'vue-property-decorator';
import PreviewTable from '@/components/Form/ScheduleSetting/PreviewTable/index.vue';

@Component({
  components: {
    PreviewTable,
  },
})
export default class RotationPreview extends Vue {
  @PropSync('partner', {}) partnerLocals: any;

  @PropSync('service', {}) serviceLocal: any;

  public allDays: any = {
    sunday: false,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
  }

  public weekOccur: any = {
    week1: false,
    week2: false,
    week3: false,
    week4: false,
    week5: false,
  }

  public mounted() {
    this.getUnitScheduleDays();
    this.getOccursWeek();
  }

  public getUnitScheduleDays() {
    if (this.serviceLocal.popupPattern) {
      const days = this.serviceLocal.popupPattern;
      const mappedData = !days || days.map((day: any) => {
        if (day === 0) {
          this.allDays.sunday = true;
        }
        if (day === 1) {
          this.allDays.monday = true;
        }
        if (day === 2) {
          this.allDays.tuesday = true;
        }
        if (day === 3) {
          this.allDays.wednesday = true;
        }
        if (day === 4) {
          this.allDays.thursday = true;
        }
        if (day === 5) {
          this.allDays.friday = true;
        }
        if (day === 6) {
          this.allDays.saturday = true;
        }
        return day;
      });
    }
    return '';
  }

  public getOccursWeek() {
    if (this.serviceLocal.weeklyOccurrence) {
      const weeks = this.serviceLocal.weeklyOccurrence;
      const mappedData = !weeks || weeks.map((week: any) => {
        if (week === 1) {
          this.weekOccur.week1 = true;
        }
        if (week === 2) {
          this.weekOccur.week2 = true;
        }
        if (week === 3) {
          this.weekOccur.week3 = true;
        }
        if (week === 4) {
          this.weekOccur.week4 = true;
        }
        if (week === 5) {
          this.weekOccur.week5 = true;
        }
        return week;
      });
    }
    return '';
  }

  public partnerPreview: any = [
    {
      text: 'Restaurant 1',
      value: 1,
    },
    {
      text: 'Restaurant 2',
      value: 2,
    },
    {
      text: 'Restaurant 3',
      value: 3,
    },
    {
      text: 'Restaurant 4',
      value: 4,
    },
    {
      text: 'Restaurant 5',
      value: 5,
    },
  ]
}
